import ArrayUtils from "../../utils/arraysUtils"
import OrdenListaObjetosConId from "./../tipos/ordenListaObjetosConId";

const TIPO_ORDEN_VARIABLES_NOMBRE = 2;

const TIPO_ORDEN_DEFECTO = TIPO_ORDEN_VARIABLES_NOMBRE;

class OrdenVariables extends OrdenListaObjetosConId{
  constructor(tipo, idsOrdenCustom) {
    super(tipo,idsOrdenCustom)
    if (!this._tipo)
      this._tipo = TIPO_ORDEN_DEFECTO;
  }

  equals(orden){
    return this.tipo === orden.tipo && ArrayUtils.equalsContents(orden.ids,this.ids);
  }

}

function createOrdenVariablesCustom() {
  return new OrdenVariables();
}

export {
  OrdenVariables as default,
  createOrdenVariablesCustom,
  TIPO_ORDEN_VARIABLES_NOMBRE
};
